import { useState } from "react";
import { Link } from "react-router-dom";

interface MapToolbarProps {
  totalArvores: number;
  filteredCount: number;
  onNewTree: () => void;
  onExportGeoJSON: () => void;
  onCenterMap: () => void;
  onToggleLayers: () => void;
  layersOpen: boolean;
}

export default function MapToolbar({
  totalArvores,
  filteredCount,
  onNewTree,
  onExportGeoJSON,
  onCenterMap,
  onToggleLayers,
  layersOpen,
}: MapToolbarProps) {
  const [showMore, setShowMore] = useState(false);

  return (
    <div className="bg-white border-b border-background-200/70 px-6 py-3">
      {/* Breadcrumb */}
      <nav aria-label="Breadcrumb" className="flex items-center gap-1.5 text-xs text-foreground-500 mb-2">
        <Link to="/" className="hover:text-accent-500 transition-colors whitespace-nowrap">
          Dashboard
        </Link>
        <i className="ri-arrow-right-s-line text-xs" aria-hidden="true"></i>
        <span className="text-foreground-800 font-medium whitespace-nowrap">Mapa Arbóreo</span>
      </nav>

      {/* Title + Actions */}
      <div className="flex items-center justify-between gap-4">
        <div>
          <h1 className="text-lg font-bold text-foreground-900 font-heading">Mapa Arbóreo</h1>
          <p className="text-xs text-foreground-500 mt-0.5">
            Visualização georreferenciada do CTA, áreas verdes, UCs, riscos e projetos ambientais.
          </p>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-xs text-foreground-500 bg-background-100 px-3 py-1.5 rounded-btn whitespace-nowrap">
            <strong className="text-foreground-800">{filteredCount}</strong> de {totalArvores} árvores visíveis
          </span>

          <button onClick={onNewTree} className="btn-primary text-xs px-3 py-2 whitespace-nowrap" title="Cadastrar nova árvore">
            <i className="ri-add-line text-sm" aria-hidden="true"></i>
            <span>Nova árvore</span>
          </button>

          <button onClick={onExportGeoJSON} className="btn-outline text-xs px-3 py-2 whitespace-nowrap" title="Exportar GeoJSON">
            <i className="ri-download-2-line text-sm" aria-hidden="true"></i>
            <span>Exportar GeoJSON</span>
          </button>

          <button onClick={onCenterMap} className="btn-outline text-xs px-3 py-2 whitespace-nowrap" title="Centralizar mapa">
            <i className="ri-focus-3-line text-sm" aria-hidden="true"></i>
            <span>Centralizar</span>
          </button>

          <button
            onClick={onToggleLayers}
            className={`text-xs px-3 py-2 rounded-btn border font-medium transition-colors duration-150 whitespace-nowrap ${
              layersOpen
                ? "bg-accent-100 text-accent-700 border-accent-300"
                : "btn-outline"
            }`}
            title="Gerenciar camadas"
          >
            <i className="ri-stack-line text-sm" aria-hidden="true"></i>
            <span>Camadas</span>
          </button>

          <div className="relative">
            <button
              onClick={() => setShowMore(!showMore)}
              className="btn-outline text-xs px-3 py-2 whitespace-nowrap"
              title="Mais ações"
            >
              <i className="ri-more-2-fill text-sm" aria-hidden="true"></i>
              <span className="hidden sm:inline">Mais ações</span>
            </button>

            {showMore && (
              <>
                <div className="fixed inset-0 z-40" onClick={() => setShowMore(false)}></div>
                <div className="absolute right-0 top-full mt-1 w-52 bg-white border border-background-200 rounded-card shadow-lg z-50 py-1">
                  <button
                    onClick={() => { setShowMore(false); }}
                    className="w-full text-left px-4 py-2.5 text-xs text-foreground-700 hover:bg-background-100 transition-colors flex items-center gap-2 whitespace-nowrap"
                  >
                    <i className="ri-file-upload-line text-sm" aria-hidden="true"></i>
                    Importar camada
                  </button>
                  <button
                    onClick={() => { setShowMore(false); }}
                    className="w-full text-left px-4 py-2.5 text-xs text-foreground-700 hover:bg-background-100 transition-colors flex items-center gap-2 whitespace-nowrap"
                  >
                    <i className="ri-save-line text-sm" aria-hidden="true"></i>
                    Salvar visão atual
                  </button>
                  <button
                    onClick={() => { setShowMore(false); }}
                    className="w-full text-left px-4 py-2.5 text-xs text-foreground-700 hover:bg-background-100 transition-colors flex items-center gap-2 whitespace-nowrap"
                  >
                    <i className="ri-printer-line text-sm" aria-hidden="true"></i>
                    Imprimir mapa
                  </button>
                  <button
                    onClick={() => { setShowMore(false); }}
                    className="w-full text-left px-4 py-2.5 text-xs text-foreground-700 hover:bg-background-100 transition-colors flex items-center gap-2 whitespace-nowrap"
                  >
                    <i className="ri-share-line text-sm" aria-hidden="true"></i>
                    Compartilhar link
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}